import React from 'react';
import InputMask from 'react-input-mask';
import { useEstabFormContext } from './Context';
import { SettingsRow, SettingsSection } from './SettingsGroup';
import { ExternalLink } from 'lucide-react';

async function fetchAddressByCep(cep: string) {
    const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
    if (!response.ok) {
        throw new Error('Erro ao buscar o endereço.');
    }
    return response.json();
}

export function EnderecoEstabelecimento() {
    const {
        zipCode,
        setZipCode,
        street,
        setStreet,
        number,
        setNumber,
        setAddressUrl,
        addressUrl,
        complement,
        setComplement,
        neighborhood,
        setNeighborhood,
        city,
        setCity,
        state,
        setState,
    } = useEstabFormContext();

    const estadosBrasileiros = [
        'AC',
        'AL',
        'AP',
        'AM',
        'BA',
        'CE',
        'DF',
        'ES',
        'GO',
        'MA',
        'MT',
        'MS',
        'MG',
        'PA',
        'PB',
        'PR',
        'PE',
        'PI',
        'RJ',
        'RN',
        'RS',
        'RO',
        'RR',
        'SC',
        'SP',
        'SE',
        'TO',
    ];

    const handleCepChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const newCep = e.target.value.replace(/\D/g, '');
        setZipCode(newCep);
        if (newCep.length === 8) {
            try {
                const data = await fetchAddressByCep(newCep);
                setStreet(data.logradouro);
                setNeighborhood(data.bairro);
                setCity(data.localidade);
                setState(data.uf);
            } catch (error) {
                console.error(error);
                // Você pode adicionar uma mensagem de erro aqui se desejar
            }
        }
    };

    return (
        <div className="grid gap-6 xl:grid-cols-2 xl:items-start">
            <SettingsSection title="Localização" footer="Ao informar o CEP, rua, bairro, cidade e estado são preenchidos automaticamente.">
                <SettingsRow label="CEP" htmlFor="cep">
                    <InputMask
                        mask="99999-999"
                        value={zipCode}
                        onChange={handleCepChange}
                        type="text"
                        id="cep"
                        inputMode="numeric"
                        placeholder="00000-000"
                        className="input estab-field"
                        maskChar={null}
                    />
                </SettingsRow>
                <SettingsRow label="Estado" htmlFor="state">
                    <select
                        id="state"
                        value={state}
                        onChange={(e) => setState(e.target.value)}
                        className="select estab-field"
                    >
                        <option value="" disabled>
                            Selecione
                        </option>
                        {estadosBrasileiros.map((estado) => (
                            <option key={estado} value={estado}>
                                {estado}
                            </option>
                        ))}
                    </select>
                </SettingsRow>
                <SettingsRow label="Cidade" htmlFor="city">
                    <input
                        type="text"
                        id="city"
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                        className="input estab-field"
                        placeholder="Cidade"
                    />
                </SettingsRow>
                <SettingsRow label="Bairro" htmlFor="neighborhood">
                    <input
                        type="text"
                        id="neighborhood"
                        value={neighborhood}
                        onChange={(e) => setNeighborhood(e.target.value)}
                        className="input estab-field"
                        placeholder="Bairro"
                    />
                </SettingsRow>
            </SettingsSection>

            <div className="space-y-6">
                <SettingsSection title="Logradouro">
                    <SettingsRow label="Rua" htmlFor="street">
                        <input
                            type="text"
                            id="street"
                            value={street}
                            onChange={(e) => setStreet(e.target.value)}
                            className="input estab-field"
                            placeholder="Rua, avenida..."
                        />
                    </SettingsRow>
                    <SettingsRow label="Número" htmlFor="number">
                        <input
                            type="text"
                            id="number"
                            value={number}
                            onChange={(e) => setNumber(e.target.value)}
                            className="input estab-field"
                            placeholder="Nº"
                        />
                    </SettingsRow>
                    <SettingsRow label="Complemento" htmlFor="complement">
                        <input
                            type="text"
                            id="complement"
                            value={complement}
                            onChange={(e) => setComplement(e.target.value)}
                            className="input estab-field"
                            placeholder="Opcional"
                        />
                    </SettingsRow>
                </SettingsSection>

                <SettingsSection title="Mapa" footer="Link do Google Maps exibido para clientes chegarem ao estabelecimento.">
                    <SettingsRow label="Link do endereço" htmlFor="addressUrl">
                        <input
                            type="url"
                            id="addressUrl"
                            className="input estab-field"
                            value={addressUrl}
                            onChange={(e) => setAddressUrl(e.target.value)}
                            placeholder="https://maps.google.com/..."
                        />
                    </SettingsRow>
                    {addressUrl && (
                        <SettingsRow stacked>
                            <a href={addressUrl} target="_blank" rel="noreferrer" className="estab-link-button -ml-1">
                                Abrir no mapa
                                <ExternalLink className="text-[0.7rem]" aria-hidden="true" />
                            </a>
                        </SettingsRow>
                    )}
                </SettingsSection>
            </div>
        </div>
    );
}
